// extracted by mini-css-extract-plugin
module.exports = {"main":"main-2RciQ0yN"};